import {useMemo} from "react";

import {compareJeffProperties, getPlanner3dData} from "../../../../constants/get_planner_3d_data";
import {useGetYslabPropertyListQuery} from "../api/yslab_investments_api";

export const useYslabPlannerPropertyData = (params: {property?: {number: string}; offerId: number}) => {
    const plannerData = getPlanner3dData(params.offerId);
    const {data} = useGetYslabPropertyListQuery({investmentId: plannerData?.yslabOfferId}, {skip: !plannerData?.yslabOfferId});

    const notSoldProperties = useMemo(() => data?.data?.filter((property) => property.status === "available"), [data]);

    const yslabProperty = useMemo(
        () =>
            notSoldProperties?.find(
                (p) =>
                    params.property &&
                    compareJeffProperties(
                        {mappingName: p.name, buildingNumber: p.buildingNumber},
                        plannerData?.allowComparisonBasedOnConfiguredBuildingName,
                        plannerData?.buildingNameMap
                    )(params.property)
            ),
        [notSoldProperties, params.property]
    );

    return {
        notSoldProperties,
        yslabProperty: yslabProperty || null
    };
};
import {useMemo} from "react";

import {compareJeffProperties, getPlanner3dData} from "../../../../constants/get_planner_3d_data";
import {useGetYslabPropertyListQuery} from "../api/yslab_investments_api";

export const useYslabPlannerPropertyData = (params: {property?: {number: string}; offerId: number}) => {
    const plannerData = getPlanner3dData(params.offerId);
    const {data} = useGetYslabPropertyListQuery({investmentId: plannerData?.yslabOfferId}, {skip: !plannerData?.yslabOfferId});

    const notSoldProperties = useMemo(() => data?.data?.filter((property) => property.status === "available"), [data]);

    const yslabProperty = useMemo(
        () =>
            notSoldProperties?.find(
                (p) =>
                    params.property &&
                    compareJeffProperties(
                        {mappingName: p.name, buildingNumber: p.buildingNumber},
                        plannerData?.allowComparisonBasedOnConfiguredBuildingName,
                        plannerData?.buildingNameMap
                    )(params.property)
            ),
        [notSoldProperties, params.property]
    );

    return {
        notSoldProperties,
        yslabProperty: yslabProperty || null
    };
};
